import { render } from "./Dashboard.vue?vue&type=template&id=690f9a76"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=690f9a76&lang=css"
script.render = render

export default script